import { OrderStatus } from "@enums";
import { Box, TableCell } from "@mui/material";
import CommentsIconButton from "@pages/CommandCenter/CommandCenterTable/CommentsIconButton";
import { OrderSearchOut } from "@providers/hop-ord-server/api";

interface Props {
  order: OrderSearchOut;
  setRowIsHovered?: (hover: boolean) => void;
}

const CommentCell = ({ order, setRowIsHovered }: Props) => {
  return (
    <TableCell sx={{ minWidth: "50px" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          paddingRight: 2,
        }}
      >
        {order.status !== OrderStatus.DRAFT && (
          <CommentsIconButton
            setRowIsHovered={setRowIsHovered}
            orderId={order.id}
            orderStatus={order.status}
            unreadCommentCount={order.unreadCommentCount || 0}
          />
        )}
      </Box>
    </TableCell>
  );
};
export default CommentCell;
